/**
 * Bewertungsanzeigen vereinheitlichen (31.10.2026)
 * Google-Bewertungen (App „Rocket Google Reviews“ / Entangle) zeigen die Note als „4,7/5“
 * und die Anzahl auf Deutsch („106 Bewertungen auf Google“).
 * Trusted Shops (Kopfleiste, Trustbadge) wird per CSS in custom.css ergänzt.
 * Trusted Stars blendet auf dem Handy die Anzahl aus – darunter steht dann „722 Bewertungen auf Trusted Shops“
 * (Zahl aus der Kopfleiste, die sie live von Trusted Shops lädt; Anzeige nur mobil per CSS).
 */
(function () {
  if (window.frRatingDisplay) return;
  window.frRatingDisplay = true;

  var LABELS = {
    excellent: 'Hervorragend',
    'very good': 'Sehr gut',
    good: 'Gut',
    fair: 'Akzeptabel',
    average: 'Akzeptabel',
    poor: 'Mangelhaft',
    'very poor': 'Ungenügend',
  };

  var dataPromise = null;

  function formatScore(value) {
    var n = parseFloat(String(value).replace(',', '.'));
    if (isNaN(n)) return null;
    return n.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
  }

  function scoreMarkup(score) {
    return '<span class="fr-rating__score">' + score + '</span><span class="fr-rating__max">/5</span>';
  }

  function loadGoogleData() {
    if (dataPromise) return dataPromise;
    var url = window.grEntangleApiUrl;
    if (!url) return Promise.resolve(null);
    url += (url.indexOf('?') === -1 ? '?' : '&') + 'locale=' + encodeURIComponent((window.Shopify && Shopify.locale) || 'de');
    dataPromise = fetch(url)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        return json && json.data ? json.data : null;
      })
      .catch(function () {
        return null;
      });
    return dataPromise;
  }

  /* Produktseite: Badge mit Zahl („4.7“) und „106 reviews on“ */
  function fixBadgeRating(el) {
    if (el.dataset.frDone) return;
    var score = formatScore(el.textContent.trim());
    if (!score) return;
    el.dataset.frDone = '1';
    el.innerHTML = scoreMarkup(score);
  }

  function fixReviewCount(el) {
    if (el.dataset.frDone) return;
    var m = el.textContent.match(/(\d[\d.,]*)\s*(reviews?|rezensionen|bewertungen)\s*(on|auf)?/i);
    if (!m) return;
    el.dataset.frDone = '1';
    el.innerHTML = '<b>' + m[1] + '</b> Bewertungen' + (m[3] ? ' auf' : '');
  }

  /* Startseite: Badge ohne Zahl („Excellent“, Sterne, „Bezogen auf 106 Rezensionen“) */
  function fixBadgeTitle(el) {
    if (el.dataset.frDone) return;
    el.dataset.frDone = '1';
    var key = el.textContent.trim().toLowerCase();
    if (LABELS[key]) el.textContent = LABELS[key];

    var container = el.parentElement;
    if (!container || container.querySelector('.grp-entangle-badge-rating, .fr-rating')) return;
    loadGoogleData().then(function (data) {
      if (!data || data.rating == null) return;
      var score = formatScore(data.rating);
      if (!score || container.querySelector('.fr-rating')) return;
      var div = document.createElement('div');
      div.className = 'fr-rating';
      div.innerHTML = scoreMarkup(score);
      el.insertAdjacentElement('afterend', div);
    });
  }

  var TRUSTED_STARS_ID = 'wdg-e1995c2e-ae7e-4222-aab4-f6f4254ca1bf';

  function fixTrustedStars(el) {
    var countEl = document.querySelector('.announcement-bar [data-ts-count]');
    var count = countEl ? countEl.textContent.trim() : '';
    if (!/^\d[\d.]*$/.test(count)) return;
    var cap = el.nextElementSibling;
    if (!cap || !cap.classList.contains('fr-trusted-stars__count')) {
      cap = document.createElement('p');
      cap.className = 'fr-trusted-stars__count';
      el.insertAdjacentElement('afterend', cap);
    }
    var html = '<b>' + count + '</b> Bewertungen auf Trusted Shops';
    if (cap.innerHTML !== html) cap.innerHTML = html;
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('etrusted-widget[data-etrusted-widget-id="' + TRUSTED_STARS_ID + '"]').forEach(fixTrustedStars);
    scope.querySelectorAll('.grp-entangle-badge-rating').forEach(fixBadgeRating);
    scope.querySelectorAll('.grp-new-num-reviews').forEach(fixReviewCount);
    scope.querySelectorAll('.grp-entangle-badge-title').forEach(fixBadgeTitle);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      run(document);
    });
  }

  function start() {
    run(document);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
